<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="package-expired-dialog"
    width="400px"
    append-to-body
  >
    <!-- 设计稿使用顶部淡红渐变，内容区不保留 Element 默认标题栏。 -->
    <section class="package-expired-dialog__content">
      <button class="package-expired-dialog__close" type="button" :aria-label="$t('common.Close')" @click="closeDialog">
        <i class="el-icon-close"></i>
      </button>
      <!-- 插画来自 Figma 导出并落盘，避免依赖会过期的设计资源链接。 -->
      <!--<img
        class="package-expired-dialog__illustration"
        :src="`${common.imageRoot}/marketingTools/package-expire.png`"
        alt=""
      />-->
      <img
        class="package-expired-dialog__illustration"
        src="@/assets/images/marketingTools/package-expire.png"
        alt=""
      />
      <h2>{{ $t("dashboard.Package-Expired-Dialog-Title") }}</h2>
      <p class="package-expired-dialog__description">{{ $t("dashboard.Package-Expired-Dialog-Content") }}</p>
      <!-- 订阅套餐跳转后同时关闭弹窗，避免返回时保留过期遮罩层。 -->
      <div class="package-expired-dialog__actions">
        <button
          type="button"
          class="package-expired-dialog__button package-expired-dialog__button--primary"
          @click="goToSubscribe"
        >
          {{ $t("dashboard.Package-Expired-Dialog-Subscribe") }}
        </button>
      </div>
    </section>
  </el-dialog>
</template>

<script setup>
import {onBeforeUnmount, onMounted, ref} from "vue";
import {eventBus} from "@/main";
import EventCenter, {getPackageExpiredPending, setPackageExpiredPending} from "@/utils/EventCenter";
import {useRouter} from "vue-router/composables";


const router = useRouter();

// 使用 Composition API 保存弹窗状态，模板会自动解包该 ref。
const visible = ref(false);

const openDialog = () => {
  // 消费待显示标志，防止残留导致后续白名单页刷新误弹。
  setPackageExpiredPending(false);
  // 同一时间的多个到期通知复用当前弹窗，不重复创建遮罩层。
  visible.value = true;
};

const closeDialog = () => {
  // 关闭仅改变当前弹窗状态，不干预触发到期提示的页面业务流程。
  visible.value = false;
};

const goToSubscribe = () => {
  // 订阅套餐前收起全局弹窗，确保新页面不会继续被遮罩层覆盖。
  closeDialog();
  router.push("/team/package/subscribe");
};

onMounted(() => {
  // 路由守卫不依赖页面实例，通过全局事件通知根节点弹出套餐到期提示。
  eventBus.$on(EventCenter.openPackageExpiredDialog, openDialog);
  // 冷启动兜底：guard 先于根节点挂载 emit 会丢失，此时靠守卫设置的标志自显。
  // 团队页/个人中心等白名单页刷新时守卫不设标志，不会误弹。
  if (getPackageExpiredPending()) {
    openDialog();
  }
});

onBeforeUnmount(() => {
  // 组件销毁时解除监听，避免热更新或重新挂载后重复触发弹窗。
  eventBus.$off(EventCenter.openPackageExpiredDialog, openDialog);
});
</script>

<style lang="scss">
// Element 的 dialog 会挂载到 body，使用非 scoped 样式并覆盖默认顶部 margin，使弹窗保持视口居中。
.package-expired-dialog {
  top: 50%;
  margin: 0 auto !important;
  transform: translateY(-50%);
  border-radius: 12px;
  overflow: hidden;
  background: linear-gradient(180deg, rgb(255 0 0 / 4%) 0%, rgb(255 0 0 / 0%) 29.742%), var(--mc-background-main-color);
  
  .el-dialog__header {
    display: none;
  }
  
  .el-dialog__body {
    padding: 0;
  }
  
  &__content {
    position: relative;
    box-sizing: border-box;
    min-height: 354px;
    padding: 40px;
    text-align: center;
  }
  
  &__close {
    position: absolute;
    top: 12px;
    right: 12px;
    display: grid;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 0;
    place-items: center;
    color: #a4acb9;
    background: transparent;
    cursor: pointer;
    
    .el-icon-close {
      font-size: 16px;
    }
  }
  
  &__illustration {
    display: block;
    width: 120px;
    height: 120px;
    margin: 0 auto 8px;
    object-fit: contain;
  }
  
  h2 {
    margin: 0;
    color: #17181a;
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
  }
  
  &__description {
    width: 320px;
    margin: 16px auto 24px;
    color: var(--mc-info-text-color);
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
  }
  
  &__actions {
    display: grid;
    gap: 8px;
  }
  
  &__button {
    width: 100%;
    min-height: 36px;
    border: 0;
    border-radius: var(--mc-border-radius-normal);
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    cursor: pointer;
    
    &--primary {
      color: var(--mc-background-main-color);
      background: var(--mc-color-primary);
    }
  }
}
</style>
